import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Tab } from './common-tabs.model';

@Component({
    selector: 'lib-common-tabs',
    imports: [RouterModule, TranslateModule],
    templateUrl: './common-tabs.component.html',
    styleUrls: ['./common-tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonTabsComponent {
    tabs = input<Tab[]>([]);
    activeValue = input<string>('');
    /** Horizontal padding variant. 'default' = 12px (--anc-space-sm-4), 'spacious' = 32px. */
    size = input<'default' | 'spacious'>('default');
    /** Visual variant. 'filled' = grey active/hover background; 'plain' = no tab background, underline indicator only. */
    variant = input<'filled' | 'plain'>('filled');
    /** Render the full-width bottom divider. Set false when the tabs sit directly above a bordered surface. */
    divider = input<boolean>(true);
    tabChange = output<Tab>();

    isRouterMode = computed(() => this.tabs().some((t) => !!t.route));
    visibleTabs = computed(() => this.tabs().filter((t) => !t.hidden));

    onTabClick(tab: Tab): void {
        if (tab.disabled) return;
        this.tabChange.emit(tab);
    }
}
